import {
    type UscCarDeliveryTempConfig,
    type UscCarDeliveryConfig,
    CarDeliveryNavStep,
    CarDeliveryDestination,
    CarDeliveryTransportationOption,
} from "../../utils/carDeliveryUtils";
import {
    type UscCarDeliveryActionsType,
    USC_CAR_DELIVERY_MODAL_SET_NAV_STEP,
    USC_CAR_DELIVERY_SET_CONFIG,
    USC_CAR_DELIVERY_SET_TEMP_DELIVERY_CONFIG,
    USC_CAR_DELIVERY_SET_DESTINATION,
    USC_CAR_DELIVERY_SET_TRANSPORTATION,
    USC_CAR_DELIVERY_SET_ERROR,
} from "../actions/UscCarDeliveryActions";

export type UscCarDeliveryReducerType = {
    initialized: boolean;
    deliveryConfig: UscCarDeliveryConfig | null;
    modal: {
        navStep: CarDeliveryNavStep;
    };
    // This is used to temporarily store the config between steps
    tempDeliveryConfig: UscCarDeliveryTempConfig | null;
    deliveryDestination: CarDeliveryDestination;
    deliveryTransportation: CarDeliveryTransportationOption;
    error: boolean;
};

export const carDeliveryInitialState: UscCarDeliveryReducerType = {
    initialized: false,
    deliveryConfig: null,
    modal: {
        navStep: CarDeliveryNavStep.Destination,
    },
    tempDeliveryConfig: null,
    deliveryDestination: CarDeliveryDestination.Dealer,
    deliveryTransportation: CarDeliveryTransportationOption.ProfessionalDriver,
    error: false,
};

const UscCarDeliveryReducer = (
    state: UscCarDeliveryReducerType = carDeliveryInitialState,
    action: UscCarDeliveryActionsType,
): UscCarDeliveryReducerType => {
    switch (action.type) {
        case USC_CAR_DELIVERY_SET_CONFIG:
            const { deliveryConfig } = action;
            return { ...state, deliveryConfig, initialized: true };

        case USC_CAR_DELIVERY_SET_TEMP_DELIVERY_CONFIG:
            const { tempDeliveryConfig } = action;
            return { ...state, tempDeliveryConfig, initialized: true };

        case USC_CAR_DELIVERY_MODAL_SET_NAV_STEP:
            const { navStep } = action;
            return { ...state, modal: { ...state.modal, navStep } };

        case USC_CAR_DELIVERY_SET_DESTINATION:
            const { destination } = action;
            return { ...state, deliveryDestination: destination };

        case USC_CAR_DELIVERY_SET_TRANSPORTATION:
            const { transportation } = action;
            return { ...state, deliveryTransportation: transportation };

        case USC_CAR_DELIVERY_SET_ERROR:
            const { error } = action;
            return { ...state, error };

        default:
            return state;
    }
};

export default UscCarDeliveryReducer;
